export default __webpack_public_path__ + "static/media/star.49259244.png";